module.exports = __webpack_public_path__ + "static/assets/eaa9867d63b76060bea72cf00b1cde81.png";